import { ICarrier, ICustomer } from '@/types';
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import {
    TextField,
    Grid,
    InputAdornment,
} from '@mui/material';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import { useUSDOTForCarrier, useGetUsDotDataForCustomer } from '@/hooks/useGetUsDotData';
import { Search as FaSearch } from '@mui/icons-material';

import { EntityType } from '@/components/common/UniversalEntityForm';
import { useAppSelector } from '@/redux/store';
const UsDotField: React.FC<{ setLocalUsdot: any, entity: EntityType }> = ({ setLocalUsdot, entity }) => {
    const isRepairCompany = useAppSelector((state) => state.user.currentCompanyDetails.type === "REPAIR SHOP")
    const form = useFormContext<ICarrier | ICustomer>();
    // Use appropriate hook based on entity type
    const carrierHook = entity === 'carrier' || isRepairCompany ? useUSDOTForCarrier(form.setValue) : { loading: false, error: null, handleSubmit: () => { } };
    const customerHook = entity === 'load-customer' || isRepairCompany ? useGetUsDotDataForCustomer(form.setValue) : { loading: false, error: null, handleSubmit: () => { } };

    const { loading: usdotLoading, error: usdotError, handleSubmit: searchUSDOT } = entity === 'carrier' ? carrierHook : customerHook;
    const handleUSDOTSearch = () => {
        const usdotValue = form.watch('usdot');
        if (usdotValue) {
            searchUSDOT(usdotValue);
            setLocalUsdot?.(usdotValue);
        }
    };
    return <Grid item xs={12} md={4}>
        <Controller
            name="usdot"
            control={form.control}
            render={({ field }) => (
                <TextField
                    {...field}
                    fullWidth
                    label="USDOT"
                    size="small"
                    error={!!form.formState.errors.usdot || !!usdotError}
                    helperText={form.formState.errors.usdot?.message || usdotError?.message}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <FaSearch
                                    onClick={handleUSDOTSearch}
                                    style={{ cursor: 'pointer', color: '#1976d2' }}
                                />
                                {usdotLoading && <LoadingSpinner />}
                            </InputAdornment>
                        ),
                    }}
                />
            )}
        />

    </Grid>

}

export default UsDotField